import styled from "styled-components";
import { ShareRegisterReceivedBG, IMG_ComfirmPin } from "@assets";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  background: url(${ShareRegisterReceivedBG}) no-repeat;
  background-size: cover;
  background-position-x: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px 16px 100px;

`;

export const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

export const Name = styled.div`
  color: #e8e03c;
  font-size: 32px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 8px;
`;

export const Welcome = styled.div`
  color: #ffffff;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding: 4px 4px 0px 4px;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
  width: calc(100%);
`;

export const Logo = styled.img.attrs({
  alt: "img",
  src: IMG_ComfirmPin,
})`
  width: 193px;
  object-fit: contain;
  position: absolute;
  top: -50px;
`;

export const DescriptionContainer = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 16px;
  width: 306px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Description = styled.div`
  color: #000;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin-top: 100px;
  width: 75%;

  span{
    color: #004F9C;
  }

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 48px !important;
  border-radius: 16px !important;
  margin-top: 30px;
`;

export const FollowTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  text-align: center;
  margin-top: 32px;
`;

export const FollowWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  gap: 8px;

  #app {
    width: 100%;
    height: 48px;
  }
`;

export const RecaptchaContainer = styled.div`
  display: flex;
  justify-content: center !important;
  align-items: center;
  width: calc(100vw - 32px);
  height: calc(100vh - 60px);

  &>div{
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
`

export const UserName = styled.div`
font-size: 15px;
font-weight: 600;
line-height: normal;
color: #004F9C;
`;

export const TypeInfo = styled.div`
padding-bottom: 15px;
font-size: 12px;
font-weight: 500;
line-height: normal;
color: #000;
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh);
	display: flex;
	align-items: center;
	justify-content: center;
`;